{
  "version": 1,
  "asset_id": "0297d2b8-fb76-4913-abe7-3fc672aee09b",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/0297d2b8-fb76-4913-abe7-3fc672aee09b/isaiah-martinez-96.webp",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/0297d2b8-fb76-4913-abe7-3fc672aee09b/isaiah-martinez-96.webp",
  "original_filename": "isaiah-martinez-96.webp",
  "size": 1244,
  "content_type": "image/webp",
  "created_at": "2026-09-18T14:37:06Z"
}
